import React, { useContext } from 'react';
import { AuthContext, AuthContextType } from 'Contexts/AuthContext';
import Login from './Login';

const LoginContainer = () => {
  const { signInUser, user, retryProfileCheck } = useContext<AuthContextType>(AuthContext);

  return <Login onSignIn={signInUser} notice={user.notice} onRetryProfile={retryProfileCheck} />;
};

export default LoginContainer;
